'use client';

import { ArrowLeft } from 'lucide-react';

import type { GHGScope } from '../types';

import { Button } from '@/components/ui/button';
interface ActivityFormHeaderProps {
  scope: GHGScope;
  activityCategory: string;
  categoryLabel?: string;
  isCreateMode: boolean;
  isLoading: boolean;
  onBack?: () => void;
}

const SCOPE_LABELS: Record<number, string> = {
  1: 'Scope 1',
  2: 'Scope 2',
  3: 'Scope 3',
};

export function ActivityFormHeader({
  scope,
  activityCategory,
  categoryLabel,
  isCreateMode,
  isLoading,
  onBack,
}: ActivityFormHeaderProps) {
  return (
    <div
      className="flex flex-wrap items-center justify-between gap-2 rounded-lg border bg-muted/20 px-4 py-3"
      data-testid="activity-form-header"
    >
      <div className="flex items-center gap-2 text-sm">
        <span className="font-medium">{SCOPE_LABELS[scope] ?? `Scope ${String(scope)}`}</span>
        <span className="text-muted-foreground">/</span>
        <span className="text-muted-foreground">{categoryLabel ?? activityCategory}</span>
      </div>
      {isCreateMode && onBack && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onBack}
          disabled={isLoading}
          className="gap-1"
          data-testid="activity-form-back-btn"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Step 1
        </Button>
      )}
    </div>
  );
}
